import React, { useContext, useReducer, useEffect, createContext } from 'react'
import { ApplicationContext } from '@contexts/ApplicationContext'
import reducer, { propsToState } from './reducer'
import { actionCreators } from './actions'

export const RiskProductsContext = createContext({})

export const RiskProductsProvider = (props) => {
  const { trackingDetails } = useContext(ApplicationContext)
  const [internalState, dispatch] = useReducer(reducer, propsToState(props))
  const stateWithProps = { ...props, ...internalState }
  const actionsWithDispatch = actionCreators(dispatch, stateWithProps)
  const { updateProps } = actionsWithDispatch

  useEffect(
    () => updateProps(props),
    [props.riskProducts]
  )

  return (
    <RiskProductsContext.Provider value={{ state: stateWithProps, trackingDetails, actions: actionsWithDispatch }}>
      {props.children}
    </RiskProductsContext.Provider>
  )
}
